import { Component, Input } from '@angular/core';

/**
 * Skeleton loader component for displaying animated placeholders while content loads.
 * Supports multiple types: chart, table, text, card, sidebar, and map layouts.
 */
@Component({
  selector: 'stena-skeleton-loader',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss'],
})
export class SkeletonLoaderComponent {
  /** The type of skeleton to display */
  @Input() type: 'chart' | 'table' | 'text' | 'card' | 'sidebar' | 'map' =
    'text';
  /** Height in pixels for chart and card types */
  @Input() height = 300;
  /** Width in pixels for text type */
  @Input() width = 200;
  /** Number of rows for table and sidebar types */
  @Input() rows = 5;
  /** Number of columns for table type */
  @Input() columns = 3;

  /**
   * Generates array of indices for skeleton elements
   * @param count Number of elements to generate
   * @returns Array of numbers representing element indices
   */
  getArray(count: number): number[] {
    return Array(count)
      .fill(0)
      .map((_, i) => i);
  }

  /**
   * Generates array of row indices for table and sidebar skeletons
   * @returns Array of numbers representing rows/items
   */
  getRows(): number[] {
    return this.getArray(this.rows);
  }

  /**
   * Generates array of column indices for table skeleton
   * @returns Array of numbers representing table columns
   */
  getColumns(): number[] {
    return this.getArray(this.columns);
  }
}
